import { useEffect, useContext } from "react";
import { post } from "../../../adapters/xhr/api";
import stylesCommonData from "./index.module.css";
import UnifiedTaxDeclarationContext from "../../../contexts/UnifiedTaxDeclarationProvider";
import ResidentialUnitsList from "./TypeLists/residentialUnitsList";
import CommercialUnitsList from "./TypeLists/commercialUnitsList";
import IndustrialFacilityUnitsList from "./TypeLists/industrialFacilityUnitsList";
import ProductionFacilityUnitsList from "./TypeLists/productionFacilityUnitsList";
import PetroleumFacilityUnitsList from "./TypeLists/petroleumFacilityUnitsList";
import MineQuarryFacilityUnitsList from "./TypeLists/mineQuarryFacilityUnitsList";
import AdministrativeUnitsList from "./TypeLists/administrativeUnitList";
import ServiceUnitList from "./TypeLists/serviceUnitList";
import FixedInstallationUnitsList from "./TypeLists/fixedIntallationUnitList";
import ServiceFacilityList from "./TypeLists/serviceFacilityList";
import HotelFacilitiesList from "./TypeLists/hotelFacilitiesList";
import VacantLandsList from "./TypeLists/vacantLandsList";

const baseUnitList = [
  {
    id: "residential",
    dataKey: "residential_units",
    label: "الوحدات السكنية",
    component: <ResidentialUnitsList />,
  },
  {
    id: "commercial_administrative_service",
    dataKey: ["commercial_units", "administrative_units", "service_units"],
    label: "الوحدات التجارية، و الإدارية، و الخدمية",
    component: (
      <>
        <ServiceUnitList />
      </>
    ),
  },
  {
    id: "service_facilities",
    dataKey: "service_facilities",
    label: "منشآت خدمية",
    component: <ServiceFacilityList />,
  },
  {
    id: "hotel_facility",
    dataKey: "hotel_facility",
    label: "المنشآت الفندقية",
    component: <HotelFacilitiesList />,
  },
  {
    id: "industrial_facility",
    dataKey: "industrial_facility",
    label: "المنشآت الصناعية",
    component: <IndustrialFacilityUnitsList />,
  },
  {
    id: "production_facility",
    dataKey: "production_facility",
    label: "المنشآت الإنتاجية",
    component: <ProductionFacilityUnitsList />,
  },
  {
    id: "mine_quarry",
    dataKey: "mine_quarry",
    label: "مناجم محاجر ملاحات",
    component: <MineQuarryFacilityUnitsList />,
  },
  {
    id: "petroleum_facility",
    dataKey: "petroleum_facility",
    label: "المنشآت البترولية",
    component: <PetroleumFacilityUnitsList />,
  },
  {
    id: "fixed_installation",
    dataKey: "fixed_installation",
    label: "التركيبات الثابتة",
    component: <FixedInstallationUnitsList />,
  },
  {
    id: "vacant_land",
    dataKey: "vacant_land",
    label: "أراضي فضاء مستغلة",
    component: <VacantLandsList />,
  },
];

const CommonLists = ({}) => {
  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const { declarationRequest } = unifiedTaxDeclarationContext;

  const filteredUnitList = baseUnitList.filter((item) => {
    // Handle multiple dataKeys (array)
    if (Array.isArray(item.dataKey)) {
      return item.dataKey.some((key) => {
        const dataProperty = declarationRequest?.[key];
        return dataProperty?.data && Array.isArray(dataProperty.data) && dataProperty.data.length > 0;
      });
    }
    // Handle single dataKey (string)
    const dataProperty = declarationRequest?.[item.dataKey];
    return dataProperty?.data && Array.isArray(dataProperty.data) && dataProperty.data.length > 0;
  });

  return (
    <div dir="rtl" className={`${stylesCommonData["units-tabs"]}`}>
      <ul className={`box-title fs-6`}>
        {filteredUnitList?.map((item) => (
          <>
            <h4 key={item.id} className="box-title mb-2">
              {item.label}
            </h4>
            <div className={`${stylesCommonData["list-body"]}`}>
              {item.component}
            </div>
          </>
        ))}
      </ul>
    </div>
  );
};
export default CommonLists;
